import React from 'react'
import classNames from "classnames";
import withStyles, { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { PhaseTag } from "../../models/PhaseTag";
import { Badge } from "@material-ui/core";
import color from "@material-ui/core/colors/amber";
import { ContextMenuTrigger } from "react-contextmenu";
import { Draggable, DraggableProvided, DraggableStateSnapshot } from '../react-beautiful-dnd';
import { ColumnType } from "./Column";
import { Tag } from "../../models/Tag";
import { LookaheadTag, LookaheadTagStatus } from "../../models/LookaheadTag";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { styles } from '../../containers/dockPadStyle'
import { ThunkDispatch } from 'redux-thunk';
import { phasePlanActions } from '../../actions/phaseplan.actions';
import { lookaheadActions } from '../../actions/lookahead.actions';
import { isTagSelected, countTagSelected } from '../../selectors/lookahead.selector';
import { Trade } from '../../models/Trade';
import { dialogActions } from '../../actions/dialog.actions';
import fontColorContrast from 'font-color-contrast';
import { alertActions } from '../../actions/alert.actions';

export interface TradeCardProps {
    classes: ClassNameMap;
    trade: Trade;
    isDisabled: boolean;
    showTradeDialogValue: (tradeId?: string) => void;
    alertError: (message: string) => void
}

const _TradeCard: React.FC<TradeCardProps> =
    ({ 
        classes,
        trade,
        isDisabled,
        showTradeDialogValue,
        alertError
    }) => {


        const onTradeClicked = () => {
            return () => {
                const tradeId = trade.uid
                if(isDisabled) {
                    alertError('Cannot Edit')
                }

                if(!tradeId || isDisabled) {
                    return
                }
    
                showTradeDialogValue(tradeId)
            }
        }

        const attributes = {
            'tradeId': !!trade.uid ? trade.uid : ""
        }

        const fontColor = fontColorContrast(trade.color)

        return (


                <ContextMenuTrigger
                    holdToDisplay={-1}
                    name={trade.name} 
                    attributes={attributes} 
                    id="trade_context_menu"
                >
                    <button 
                        onClick={onTradeClicked()} 
                        style={{backgroundColor: trade.color}} 
                        className={classNames(classes.PhasePlanTradeCard, classes.TransparentButton)}>
                        <span style={{'-webkit-font-smoothing':'auto', color: fontColor}}>
                            {trade.name}
                        </span>
                    </button>

                </ContextMenuTrigger>
        )
}

const mapStateToProps = (state:any, ownProps?: any) => ({


});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        showTradeDialogValue: (tradeId:string | null) => dispatch(dialogActions.showTradeDialog(tradeId)),
        alertError: (message: string) => dispatch(alertActions.error(message))
    }
};
export const TradeCard =  compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(_TradeCard);


// WEBPACK FOOTER //
// ./src/components/PhasePlan/TradeCard.tsx